import { useEffect, useRef, useState } from "react";

/**
 * Adds a 'revealed' class when the element enters the viewport.
 * Pair with .reveal-on-scroll in index.css.
 */
export default function useReveal(options = { threshold: 0.15 }) {
  const ref = useRef(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setRevealed(true);
            obs.unobserve(entry.target);
          }
        });
      },
      options
    );
    obs.observe(el);
    return () => obs.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { ref, className: `reveal-on-scroll ${revealed ? "revealed" : ""}` };
}
